export default __webpack_public_path__ + "static/media/REC.adc7d862.png";